module.exports = __webpack_public_path__ + "img/img8.4de8d2e2.png";